export { OfferLineMinimal as OfferLineMinimalEnhanced } from "./OfferLineMinimal";
